import { AuthContextProps, ChatData, History } from "../../shared/data/types";

export interface FetchProps {
  sendRequest: (
    url: string,
    method?: string,
    body?: BodyInit,
    headers?: HeadersInit,
    successMessage?: boolean,
    zeroResultsKey?: string,
    pollOnTimeout?: boolean
  ) => Promise<any>;
  auth: AuthContextProps;
}

export interface FetchNoAuthProps {
  sendRequest: (
    url: string,
    method?: string,
    body?: BodyInit,
    headers?: HeadersInit,
    successMessage?: boolean,
    zeroResultsKey?: string,
    pollOnTimeout?: boolean
  ) => Promise<any>;
}

// SEND SUPPORT MESSAGE /////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
interface SendSupportMessageProps extends FetchProps {
  setLoadedChat: React.Dispatch<React.SetStateAction<ChatData>>;
  loadedChat: ChatData;
  message: string;
  files: File[];
  history: History;
  setExtIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const sendSupportMessage = async (props: SendSupportMessageProps) => {
  const {
    sendRequest,
    setLoadedChat,
    loadedChat,
    message,
    auth,
    files = [],
    history,
    setExtIsLoading,
  } = props;

  const formData = new FormData();
  formData.append("message", message);
  files.forEach((file) => {
    formData.append("files", file as Blob);
  });

  try {
    const responseData:
      | {
          chat: ChatData;
          ticketId: string | null;
        }
      | { reqTimeout: true } = await sendRequest(
      `${process.env.REACT_APP_BACKEND_URL}/chats/support`,
      "POST",
      formData,
      {
        Authorization: `Bearer ${auth.token}`,
      },
      false,
      "items",
      true
    );

    if (
      !!(
        responseData as {
          chat: ChatData;
          ticketId: string | null;
        }
      )?.chat
    ) {
      setLoadedChat(
        (
          responseData as {
            chat: ChatData;
            ticketId: string | null;
          }
        )?.chat
      );
      if (
        (
          responseData as {
            chat: ChatData;
            ticketId: string | null;
          }
        )?.ticketId
      ) {
        history.push(
          `/ticket/${
            (
              responseData as {
                chat: ChatData;
                ticketId: string | null;
              }
            )?.ticketId
          }`
        );
      }
    }

    if (!!(responseData as { reqTimeout: true })?.reqTimeout) {
      setExtIsLoading(true);
      setTimeout(() => {
        pollForChatUpdate({
          sendRequest,
          setLoadedChat,
          loadedChat: loadedChat,
          setExtIsLoading,
          history,
        });
      }, 5000);
    }
  } catch (err) {}
};

// POLL FOR CHAT UPDATE /////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
interface PollForChatUpdateProps extends FetchNoAuthProps {
  setLoadedChat: React.Dispatch<React.SetStateAction<ChatData>>;
  loadedChat: ChatData;
  setExtIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  history: History;
}

export const pollForChatUpdate = async (props: PollForChatUpdateProps) => {
  const { sendRequest, setLoadedChat, loadedChat, setExtIsLoading, history } =
    props;

  const chatId = loadedChat?._id;
  const lastAssistanMessagetId =
    loadedChat?.conversationHistory
      ?.filter((ch) => {
        return ch.role === "assistant";
      })
      ?.slice(-1)?.[0]?._id || "";

  try {
    const responseData: {
      chat: ChatData;
      updated: boolean;
    } = await sendRequest(
      `${process.env.REACT_APP_BACKEND_URL}/chats/polling/${chatId}/${lastAssistanMessagetId}`,
      "GET",
      null,
      {
        "Content-Type": "application/json",
      }
    );

    if (!responseData.updated) {
      setExtIsLoading(true);
      setTimeout(() => {
        pollForChatUpdate({
          sendRequest,
          setLoadedChat,
          loadedChat: loadedChat,
          setExtIsLoading,
          history,
        });
      }, 5000);
    } else {
      setExtIsLoading(false);
      setLoadedChat(responseData.chat);

      const lastAssistantMessage = responseData.chat?.conversationHistory
        ?.filter((ch) => {
          return ch.role === "assistant";
        })
        ?.slice(-1)?.[0];

      if (!!lastAssistantMessage?.ticketId) {
        history.push(`/ticket/${lastAssistantMessage?.ticketId}`);
      }
    }
  } catch (err) {}
};
